module.exports = __webpack_public_path__ + "static/media/bulk_master_customer.16429f4a.csv";